import { ReactNode, useEffect } from 'react';

import styles from './SignupLayout.module.css';
import SignupLayoutHeading from './SignupLayoutHeading';
import SignupLayoutHeadingDirectUK from './SignupLayoutHeadingDirectUK';
import { useCurrentStep } from '../../hooks/useCurrentStep';
import { useLocale } from '../../hooks/useLocale';
import { useSignupParams } from '../../hooks/useSignupParams';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import logger from '../../utils/logger';
import LogoHeading from '../LogoHeading/LogoHeading';
import MyAccount from '../MyAccount/MyAccount';
import PoweredByIwoca from '../PoweredByIwoca/PoweredByIwoca';
import Help from '../SidePanel/Help/Help';
import SidePanel from '../SidePanel/SidePanel';
import TrustPilot from '../TrustPilot/TrustPilot';

type TProps = {
  children: ReactNode;
};

const SignupLayout = ({ children }: TProps) => {
  const { isMobile } = useWindowDimensions();
  const currentStep = useCurrentStep();
  const { isDirectCustomer } = useSignupParams();
  const { isUK } = useLocale();

  const showSidePanel = !(
    isMobile &&
    currentStep !== 'new' &&
    currentStep !== 'neu'
  );

  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  // Reload page if restored by bfcache
  useEffect(() => {
    const handleRefetch = (event: PageTransitionEvent) => {
      if (event.persisted) {
        logger.info('Reloading page after event persisted');
        window.location.reload();
      }
    };

    window.addEventListener('pageshow', handleRefetch);

    return () => window.removeEventListener('pageshow', handleRefetch);
  }, []);

  return (
    <div className={styles.container}>
      {isMobile && <LogoHeading />}
      {showSidePanel && <SidePanel />}
      <div className={styles.signupContainer}>
        {isDirectCustomer && isUK && <SignupLayoutHeadingDirectUK />}
        {!(isDirectCustomer && isUK) && !isMobile && <SignupLayoutHeading />}
        <div className={styles.signupStepContainer}>{children}</div>
      </div>
      {isMobile && (
        <>
          {!isDirectCustomer && isUK && (
            <div className={styles.myAccountContainer}>
              <MyAccount />
            </div>
          )}
          <hr className={styles.footerBreak} />
          <div className={styles.footer}>
            <Help expanded />
            <div>
              <PoweredByIwoca />
              <TrustPilot />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SignupLayout;
